import React, { useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "reactstrap";
import { InputField } from "../../Component/Common/InputField";
import { checkFormError, handleKeyDown } from "../../helper";
import { modalInputSchema } from "../../helper/errorSchema";
import { deleteFullVoterAc } from "../../services/voterService";
import { getStorage } from "../../helper/storage";
import { invalidateVoterCache } from "./components/voterCache";

// The old "Delete By Ac No" modal from FullVoter.js, moved to its own routed
// page. Same API call (deleteFullVoterAc -> DELETE voter/delete-by-ac-no) -
// only the trigger/presentation changed.
export const DeleteVoter = () => {
  const navigate = useNavigate();
  const userLogin = getStorage("logged-in");
  const [inputValue, setInputValue] = useState({});
  const [inputError, setInputError] = useState({});
  const [isLoadding, setIsLoadding] = useState(false);

  const goBackToSearch = () => navigate("/voter-management/search");

  const deleteAcMutation = useMutation(deleteFullVoterAc, {
    onSuccess: (res) => {
      if (res?.success) {
        invalidateVoterCache(); // voters removed - next visit reloads the list
        toast.success(res?.message || "success");
        setIsLoadding(false);
        goBackToSearch();
      } else {
        setIsLoadding(false);
      }
    },
    onError: () => setIsLoadding(false),
  });

  const handleOnChange = async (name, value) => {
    const stateObj = { ...inputValue, [name]: value };
    setInputValue(stateObj);
    const error = await checkFormError(stateObj, modalInputSchema);
    setInputError(error);
  };

  const onSubmitDelete = () => {
    setIsLoadding(true);
    deleteAcMutation.mutate({
      ac_no: inputValue?.ac_no,
      app_name: userLogin?.app_name,
      party_name: userLogin?.party_name,
    });
  };

  return (
    <Modal isOpen toggle={goBackToSearch} centered className="avf-dialog" contentClassName="avf-content">
      <div className="avf-header">
        <div className="avf-header-top">
          <div>
            <h2 className="avf-title">Delete By AC No</h2>
            <p className="avf-subtitle">Permanently delete every voter record under an assembly number</p>
          </div>
          <button type="button" className="avf-close-btn" onClick={goBackToSearch} aria-label="Close">
            ×
          </button>
        </div>
      </div>

      <div className="avf-body">
        <div className="avf-section">
          <div className="avf-section-head">
            <span className="avf-section-num">1</span>
            <h3 className="avf-section-title">Assembly Number</h3>
          </div>
          <div className="avf-grid">
            <div className="avf-field">
              <InputField
                floating
                className="modal_input"
                label="Enter AC No"
                labelClass="modal_label"
                labelSpan="*"
                labelSpanClass="style_for_star"
                placeholder="Enter AC No"
                name="ac_no"
                maxLength={4}
                onKeyDown={handleKeyDown}
                focus={!!inputError.ac_no}
                error={inputError.ac_no}
                value={inputValue?.ac_no}
                onChange={({ target: { name, value } }) => handleOnChange(name, value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="avf-footer">
        <div className={`avf-footer-note ${inputError?.ac_no ? "has-errors" : ""}`}>
          {inputError?.ac_no || "This action cannot be undone"}
        </div>
        <div className="avf-footer-actions">
          <button type="button" className="avf-btn avf-btn-secondary" onClick={goBackToSearch}>
            Cancel
          </button>
          {isLoadding ? (
            <button type="button" className="avf-btn avf-btn-danger" disabled>
              Processing...
            </button>
          ) : (
            <button type="button" className="avf-btn avf-btn-danger" disabled={!inputValue?.ac_no} onClick={onSubmitDelete}>
              Delete
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};
